export const ACT_IDS = {
    /**
     * AMI 1.1 Analgésie topique - act_0503
     */
    AMIX_1p1_ANALGESIE_TOPIQUE: "act_0503",
    /**
     * IFI 0.01 - act_0542
     */
    IFI_0p01: "act_0542",
    /**
     * AIS 3 - act_0396
     */
    AIS_3: "act_0396",
    /**
     * AMIX 9 Forfait perfusion courte - act_0407
     */
    AMIX_9_PERF_COURTE: "act_0407",
    /**
     * AMIX 10 Forfait perfusion courte sur patient cancéreux ou immuno-déprimé - act_0417
     */
    AMIX_10_PERF_COURTE: "act_0417",
    /**
     * AMIX 1.5 Prélèvement par ponction veineuse directe (Prise de sang) - act_0343
     */
    AMIX_1p5_PRISE_DE_SANG: "act_0343",
    /**
     * AMI 2 - Retrait de sonde urinaire post-op - act_0482
     */
    AMI_2_RETRAIT_SONDE_URINAIRE_POSTOP: "act_0482",
    /**
     * AMI 2.8 - Surveillance de drain de redon et/ ou retrait postopératoire de drain - act_0485
     */
    AMI_2p8_SURVEILLANCE_DRAIN_POSTOP: "act_0485",
    /**
     * AMI 4.2 - Séance de surveillance et/ ou retrait de cathéter périnerveux pour analgésie postopératoire
     */
    AMI_4p2_SEANCE_SURVEILLANCE_ANALGESIE_POSTOP: "act_0484",
    /**
     * AMI 3.9 - Séance de surveillance clinique et d’accompagnement postopératoire à domicile pour les patients éligibles à la chirurgie ambulatoire ou à un parcours de soins de réhabilitation améliorée (RAAC)
     */
    AMI_3p9_SEANCE_SURVEILLANCE_DOMICILE_POSTOP: "act_0483"
};